import { addCyPrefixToIDs } from 'moet-test-utils/cypress/utils';

const cyPrefix = 'containers_pre_assessment_overview_container';

let ids = {
  BTN_NEW: 'BTN_NEW',
};
ids = addCyPrefixToIDs(cyPrefix, ids);

export const CY_PRE_ASSESSMENT_OVERVIEW_CONTAINER_IDS = ids;

export const POLLING_INTERVAL = 5 * 1000;
